module.exports = __webpack_public_path__ + "statics/img/earthwork-3-pay.01846ef0.png";